import getAffiliateId from '../../utils/get_affiliate_id';
import MyIcon from '../MyIcon/MyIcon';
import './CardCreative.css';

function CardCreative({ creative, onCopy, onView }) {
  const affiliate_id = getAffiliateId();
  const code = `<a href="${creative.url}?ref=${affiliate_id}><img src="${creative.image}" alt="${creative.name}" /></a>`;

  return (
    <div className="creative-card">
      <div className="card-img-top">
        <img src={creative?.image} alt={creative?.name} />
      </div>
      <div className="card-footer">
        <button type="button" className="card-link" onClick={onView}>
          <MyIcon name="eye" />
          Xem
        </button>
        <button type="button" className="card-link" onClick={(e) => onCopy(e, code)}>
          <MyIcon name="copy" />
          Copy
        </button>
      </div>
    </div>
  )
}

export default CardCreative;
